import { Container } from '#app/components/layout/container.tsx'
import { H1 } from '#app/components/typography/h1.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { P } from '#app/components/typography/p.tsx'

export const handle = {
	breadcrumb: 'Roadmap',
}

export default function RoadmapRoute() {
	return (
		<Container>
			<H1>Roadmap</H1>
			<P className="text-lg">VerveUI aims at being a full component suite with patterns and templates.</P>

			<H2>Building blocks for your UI</H2>
			<P>
				Having low-level lego pieces to build your UI is cool. But building a relatively simple header with logo, accessible menu items, and a button that opens a drawer for mobile users
				can take quite a few hours.
			</P>
			<P>
				À lá atomic design, VerveUI aims at providing higher-level components (or patterns) that are ready to use out of the box. These components are built with the low-level lego
				pieces and you just have to choose the particular layout you want.
			</P>
			<P>From these patterns, we can build templates that are ready to use in your app.</P>
		</Container>
	)
}
